export function popupResetInitialStateRequest() {
  return {
    type: '@popup/RESET_INITIAL_STATE_REQUEST'
  }
}

export function popupResetInitialStateSuccess() {
  return {
    type: '@popup/RESET_INITIAL_STATE_SUCCESS'
  }
}

export function popupResetInitialStateFailure() {
  return {
    type: '@popup/RESET_INITIAL_STATE_FAILURE'
  }
}
